import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../../../lib";
import { failureHash } from "./plan_product.static";
export class ApiEpBillingProductPlanProduct {
}
ApiEpBillingProductPlanProduct.list = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/plan-product/`,
    method: "GET",
    query: req === null || req === void 0 ? void 0 : req.query,
});
ApiEpBillingProductPlanProduct.purchase = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/plan-product/${req.path.id}/purchase`,
    method: "POST",
}, failureHash);
ApiEpBillingProductPlanProduct.retrieve = (req) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/plan-product/${req.path.id}`,
    method: "GET",
});
ApiEpBillingProductPlanProduct.trial = (req) => apiRequest({
    body: req.body,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/billing/product/plan-product/${req.path.id}/trial`,
    method: "POST",
}, failureHash);
//# sourceMappingURL=plan_product.js.map